import { ActionFunctionArgs, redirect } from 'react-router-dom'
import { z } from 'zod'

import { patientSchema } from '@/schema.ts'
import { action as createAppointmentAction } from '@/screens/createAppointmentAction.ts'
import { useAppointmentStore } from '@/store.ts'
import { isValidDateOfBirth } from '@/utils/getAllowedTreatmentsVelthuis.ts'

interface ActionData {
  errors?: z.ZodIssue[]
  error?: string
}

const action = async ({
  request,
}: ActionFunctionArgs): Promise<ActionData | Response> => {
  const { appointmentType, setError, setPatientData } =
    useAppointmentStore.getState()
  const formData = await request.formData()
  const dateOfBirth = String(formData.get('dateOfBirth'))

  const patientData = {
    dateOfBirth: String(formData.get('dateOfBirth')),
    email: String(formData.get('email')),
    firstName: String(formData.get('firstName')),
    initials: String(formData.get('initials')),
    lastName: String(formData.get('lastName')),
    phone: String(formData.get('phone')),
  }
  setPatientData(patientData)

  const result = patientSchema.safeParse(patientData)

  if (!result.success) {
    return { errors: result.error.issues }
  }

  if (!isValidDateOfBirth(dateOfBirth, appointmentType!)) {
    setError('canNotAcceptPatientsUnder18')
    return redirect('/error')
  }
  return createAppointmentAction()
}

export type { ActionData }
export { action }
